var _circle, _rect, _mask, _rect2, _path, _line, _line2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnBacPassed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#6FCF97"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4682,
    y: 16.0136,
    width: 17.6091,
    height: 29.2455,
    rx: 1.35,
    stroke: "white",
    strokeWidth: 1.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.1818,
    y: 21.1818,
    width: 10.1818,
    height: 7.27273,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1818,
    y: 21.1818,
    width: 10.1818,
    height: 7.27273,
    rx: 1,
    stroke: "white",
    strokeWidth: 2.6,
    mask: "url(#path-3-inside-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.65 18.65H41.5C42.5217 18.65 43.35 19.4783 43.35 20.5C43.35 21.5217 42.5217 22.35 41.5 22.35H36.65V18.65Z",
    stroke: "white",
    strokeWidth: 1.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.2864,
    y1: 32.1682,
    x2: 30.2591,
    y2: 32.1682,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.2864,
    y1: 36.5318,
    x2: 30.2591,
    y2: 36.5318,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8182C12 13.6049 14.6049 11 17.8182 11",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9091 16.8182C14.9091 15.2116 16.2115 13.9091 17.8181 13.9091",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBacPassed);
export default __webpack_public_path__ + "static/media/icn-bac-passed.f894e8a1.svg";
export { ForwardRef as ReactComponent };